<template>
  <md-field v-bind="{ mdClearable: $attrs.mdClearable }" @md-clear="clear">
    <label>Rate</label>
    <md-select
      v-bind:value="value"
      v-on:input="$listeners['input']"
      v-bind="$attrs"
    >
      <toggle-all-option
        v-if="Array.isArray(value)"
        :value="value"
        :types="types"
        @toggleAll="toggleAll"
      ></toggle-all-option>

      <md-option 
        v-for="type in types" 
        :key="type.id" 
        :value="type.id"
      >
        {{type.name}}
      </md-option>
    </md-select>
  </md-field>
</template>

<script>
import RatesApi from '@/openapi/src/api/RatesApi.js'
import SelectMixins from './SelectMixins'
import ToggleAllOption from "./ToggleAllOptionComponent";

export default {
  name: 'RateSelect',
  components: { ToggleAllOption },
  mixins: [SelectMixins],
  props: {
    value: {
      type: [String, Array],
    }
  },
  methods: {
    clear() {
      if (Array.isArray(this.value)) this.value = []
      else this.value = null
    },
  },
  created() {
    if (!this.$store.getters.get(this.$options.name)) {
      var api = new RatesApi()
      this.$store.dispatch('fetch', {
        name: this.$options.name,
        function: api.getRates.bind(api, this.$root.hotelId),
      })
    }
  },
  computed: {
    types() {
      return this.$store.getters.get(this.$options.name)
    }
  }
}
</script>
